import React, { useState } from 'react';
import { scenesApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function Scenes() {
  const { data: scenes, loading, error, reload } = useApiData(() => scenesApi.list());
  const [runningId, setRunningId] = useState(null);

  const handleRun = async (id) => {
    setRunningId(id);
    try {
      await scenesApi.execute(id);
    } finally {
      setRunningId(null);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Scenes</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={scenes?.length === 0} emptyLabel="No scenes yet.">
        <div className="grid md:grid-cols-3 gap-4">
          {scenes?.map((s) => (
            <button
              key={s.id}
              onClick={() => handleRun(s.id)}
              disabled={runningId === s.id}
              className="glass rounded-xl p-5 text-left hover:bg-white/5 transition-colors disabled:opacity-50"
            >
              <p className="font-medium">{s.name}</p>
              {s.action_count != null && (
                <p className="text-white/40 text-xs mt-1">{s.action_count} action{s.action_count === 1 ? '' : 's'}</p>
              )}
              <span className="inline-block mt-3 text-xs text-[#00d4ff]">
                {runningId === s.id ? 'Running…' : 'Run now →'}
              </span>
            </button>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
